import React from 'react'
import { Link } from 'react-router-dom'
import { RsIcon, IconBadge, STAT_ICON_MAP } from '../icons'

export function QuickAction({ icon, children, to, onClick, className = '' }) {
  const cls = `portal-quick-btn ${className}`.trim()
  if (to) {
    return (
      <Link to={to} className={cls}>
        <RsIcon name={icon} size="sm" />
        {children}
      </Link>
    )
  }
  return (
    <button type="button" className={cls} onClick={onClick}>
      <RsIcon name={icon} size="sm" />
      {children}
    </button>
  )
}

export function CardTitle({ icon, children }) {
  return (
    <span className="portal-card-title">
      <RsIcon name={icon} size="sm" />
      {' '}
      {children}
    </span>
  )
}

export function PortalStatCard({ label, value, change, statKey }) {
  const meta = STAT_ICON_MAP[statKey] || { icon: 'chart', tone: 'blue' }
  const toneClass = `si-${meta.tone === 'gold' ? 'orange' : meta.tone}`
  const trendUp = String(change || '').includes('+') || String(change || '').includes('↑')
  const trendDown = String(change || '').includes('↓') || String(change || '').includes('urgent')

  return (
    <div className="portal-stat-card">
      <div className="portal-stat-header">
        <span className="portal-stat-label">
          <RsIcon name={meta.icon} size="sm" />
          {' '}
          {label}
        </span>
        <div className={`portal-stat-icon rs-icon-badge ${toneClass}`}>
          <RsIcon name={meta.icon} size="md" />
        </div>
      </div>
      <div className="portal-stat-value">{value}</div>
      {change && (
        <div className={`portal-stat-change${trendUp ? ' up' : trendDown ? ' down' : ''}`}>
          {change}
        </div>
      )}
    </div>
  )
}

export function PortalTaskItem({ title, meta, priority = 'normal' }) {
  return (
    <div className="portal-task-item">
      <div className="portal-task-check" />
      <div style={{ flex: 1 }}>
        <div className="portal-task-title">{title}</div>
        {meta && <div className="portal-task-meta">{meta}</div>}
      </div>
      <span className={`portal-task-priority ${priority}`}>
        {priority.charAt(0).toUpperCase() + priority.slice(1)}
      </span>
    </div>
  )
}

export function PortalNotifItem({
  icon, bg, title, time, unread = false, onClick,
}) {
  const iconNode = typeof icon === 'string' ? <RsIcon name={icon} size="md" /> : icon
  return (
    <div
      className={`portal-notif-item${unread ? ' unread' : ''}${onClick ? ' clickable' : ''}`}
      onClick={onClick}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter') onClick(e) } : undefined}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {unread && <span className="portal-notif-unread-dot" aria-hidden />}
      <div className="portal-notif-icon" style={{ background: bg }}>{iconNode}</div>
      <div style={{ flex: 1 }}>
        <div className="portal-notif-title">{title}</div>
        {time && <div className="portal-notif-time">{time}</div>}
      </div>
    </div>
  )
}

export function PortalActivityItem({ dot, children, time }) {
  return (
    <div className="portal-activity-item">
      <div className={`portal-activity-dot ${dot}`} />
      <div style={{ flex: 1 }}>
        <div className="portal-activity-content">{children}</div>
        {time && <div className="portal-activity-time">{time}</div>}
      </div>
    </div>
  )
}

export { IconBadge }
